import React, { useState, useEffect } from 'react';
import { Table, Form, Input, Button, Space, Tag, message } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import { getResetRecords } from '../../api/serial';
import { useVisibleFields } from '../../hooks/usePermission';

const STATUS_COLOR = { '已授权': 'processing', '已授权(下发)': 'processing', '已绑定': 'success' };

const ResetRecords = () => {
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

    const fetchList = async (params = {}) => {
        setLoading(true);
        try {
            const res = await getResetRecords({ page: params.page || 1, page_size: params.page_size || 10, ...params });
            if (res.code === 0) {
                setDataSource(res.data.list);
                setPagination((prev) => ({ ...prev, total: res.data.total }));
            } else {
                message.error(res.message || '获取列表失败');
            }
        } catch (error) {
            console.error('Fetch reset records failed:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);

    const handleSearch = () => {
        fetchList({ ...form.getFieldsValue(), page: 1 });
    };

    const handleReset = () => {
        form.resetFields();
        fetchList({ page: 1 });
    };

    const visibleFields = useVisibleFields('serial:reset-records');
    const show = (code) => visibleFields.has(code);

    const columns = [
        show('sn') && { title: 'SN', dataIndex: 'sn', key: 'sn', width: 150 },
        show('mac') && { title: 'MAC', dataIndex: 'mac', key: 'mac', width: 180 },
        show('fields') && {
            title: '平台字段', dataIndex: 'fields', key: 'fields',
            render: (fields) => (
                <Space wrap size={4}>
                    {Object.entries(fields || {}).map(([k, v]) => (
                        <Tag key={k}>{k}：{v}</Tag>
                    ))}
                </Space>
            ),
        },
        show('before_status') && {
            title: '重置前授权状态', dataIndex: 'before_status', key: 'before_status', width: 140,
            render: (v) => <Tag color={STATUS_COLOR[v] || 'default'}>{v}</Tag>,
        },
        show('order_no') && { title: '工单号', dataIndex: 'order_no', key: 'order_no', width: 130, render: (v) => v || '-' },
        show('purpose') && { title: '串码用途', dataIndex: 'purpose', key: 'purpose', width: 90, render: (v) => v || '-' },
        show('factory') && { title: '生产工厂', dataIndex: 'factory', key: 'factory', width: 90 },
        show('model') && { title: '设备型号', dataIndex: 'model', key: 'model', width: 110 },
        show('reset_time') && { title: '重置时间', dataIndex: 'reset_time', key: 'reset_time', width: 180 },
        show('operator') && { title: '操作人', dataIndex: 'operator', key: 'operator', width: 120 },
    ].filter(Boolean);

    return (
        <div style={{ padding: '16px' }}>
            <Form form={form} layout="inline" style={{ marginBottom: 16, rowGap: 16 }}>
                <Form.Item name="mac">
                    <Input placeholder="MAC" allowClear style={{ width: 180 }} />
                </Form.Item>
                <Form.Item name="sn">
                    <Input placeholder="SN" allowClear style={{ width: 160 }} />
                </Form.Item>
                <Form.Item>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                        <Button icon={<ReloadOutlined />} onClick={handleReset}>重置</Button>
                    </Space>
                </Form.Item>
            </Form>

            <Table
                rowKey="id"
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={pagination}
                scroll={{ x: 1200 }}
            />
        </div>
    );
};

export default ResetRecords;
